
  import React from "react"
  import Component from "/Users/saddykiller/Development/RUBAE/rubae/src/layouts/index.js"
  import data from "/Users/saddykiller/Development/RUBAE/rubae/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js